import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ConfirmModal from '../components/ConfirmModal';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Xodimlar() {
  const { user, token } = useAuth();
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    showConfirmModal: false,
    staffToDelete: null
  });
  const [editMode, setEditMode] = useState(false);
  const [currentStaff, setCurrentStaff] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    full_name: '',
    is_active: true
  });

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/staffs', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Staff data received:', data);
      setStaff(data);
    } catch (error) {
      console.error('Failed to fetch staff:', error);
      alert('Failed to fetch staff: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && user?.role === 'owner') {
      fetchStaff();
    }
  }, [token, user?.role]);

  const handleInputChange = (e, field) => {
    const { value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [field]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      console.log('Submitting staff data:', formData);

      const url = editMode
        ? `/api/staffs/${currentStaff.id}`
        : '/api/staffs';
      const method = editMode ? 'PUT' : 'POST';

      console.log('Making', method, 'request to:', url);

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      console.log('Response status:', response.status);
      const responseData = await response.json();
      console.log('Full response:', responseData);

      if (!response.ok) {
        throw new Error(responseData.message || 'Request failed');
      }

      alert(`Staff ${editMode ? 'updated' : 'created'} successfully`);
      setShowModal(false);
      fetchStaff();
    } catch (error) {
      console.error('Error:', error);
      console.error('Error stack:', error.stack);
      alert(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = (staff) => {
    setCurrentStaff(staff);
    setEditMode(true);
    setFormData({
      username: staff.username,
      password: '',
      full_name: staff.full_name,
      is_active: staff.is_active
    });
    setShowModal(true);
  };

  const handleDelete = (staffId) => {
    setDeleteConfirmation({
      showConfirmModal: true,
      staffToDelete: staffId
    });
  };

  const confirmDelete = async () => {
    if (!deleteConfirmation.staffToDelete) return;

    setLoading(true);
    try {
      const response = await fetch(`/api/staffs/${deleteConfirmation.staffToDelete}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('API response:', response);

      if (!response.ok) {
        throw new Error('Failed to delete staff');
      }

      alert('Staff deleted successfully');
      fetchStaff();
    } catch (error) {
      console.error('Delete staff error:', error);
      alert('Failed to delete staff: ' + error.message);
    } finally {
      setLoading(false);
      setDeleteConfirmation({
        showConfirmModal: false,
        staffToDelete: null
      });
    }
  };

  if (user?.role !== 'owner') {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">
          You don't have permission to access this page. Only owners can manage staff.
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-4">
        <h2>Xodimlar</h2>
        <button
          className="btn btn-success"
          onClick={() => {
            setEditMode(false);
            setFormData({
              username: '',
              password: '',
              full_name: '',
              is_active: true
            });
            setShowModal(true);
          }}
        >
          Xodim yaratish
        </button>
      </div>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="table-responsive shadow rounded-4">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Login</th>
                <th>Ism va familya</th>
                <th>Status</th>
                <th>Amallar</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center">No staff members found</td>
                </tr>
              ) : (
                staff.map(staffMember => (
                  <tr key={staffMember.id} className={!staffMember.is_active ? 'table-danger' : ''}>
                    <td>{staffMember.username}</td>
                    <td>{staffMember.full_name}</td>
                    <td>
                      <span className={`badge ${staffMember.is_active ? 'bg-success' : 'bg-danger'}`}>
                        {staffMember.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleEdit(staffMember)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(staffMember.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal show" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editMode ? 'Edit Staff' : 'Add Staff'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Login</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.username}
                      onChange={(e) => handleInputChange(e, 'username')}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Parol</label>
                    <input
                      type="password"
                      className="form-control"
                      value={formData.password}
                      onChange={(e) => handleInputChange(e, 'password')}
                      placeholder={editMode ? 'Leave blank to keep current password' : ''}
                      required={!editMode}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Ism va familya  </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.full_name}
                      onChange={(e) => handleInputChange(e, 'full_name')}
                      required
                    />
                  </div>
                  <div className="mb-3 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={formData.is_active}
                      onChange={(e) => handleInputChange(e, 'is_active')}
                      id="isActiveCheckbox"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheckbox">Active</label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                    disabled={submitting}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={submitting}>
                    {submitting ? 'Yuklanmoqda...' : (editMode ? 'Update' : 'Create')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <ConfirmModal
        show={deleteConfirmation.showConfirmModal}
        message="Are you sure you want to delete this staff member?"
        onConfirm={confirmDelete}
        onCancel={() => setDeleteConfirmation({
          showConfirmModal: false,
          staffToDelete: null
        })}
        loading={loading}
      />
    </div>
  );
}